<template>
  <div class="select-item">
    <div class="select-item-cnt">
      <van-cell :title="title" :value="value" is-link @click="showPopup" />

      <van-popup
        closeable
        :close-on-click-overlay="false"
        v-model:show="show"
        position="bottom"
        :style="{ height: '30%' }"
        @close="close"
      >
        <div class="select-item-cnt-cell">
          <van-cell
            v-for="item in list"
            :key="item.id"
            :title="item[name]"
            @click="select(item)"
          >
          </van-cell>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue";
export default {
  name: "SelectItem",
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    list: {
      type: Object,
    },
    name: {
      type: String,
      default: "",
    },
    handlerSelect: {
      type: Function,
    },
  },

  setup(props) {
    const state = reactive({
      title: props.title,
      value: props.value,
      show: false,
      list: props.list,
      name: props.name,
    });
    const showPopup = () => {
      state.show = true;
    };
    const close = () => {
      state.show = false;
    };
    const select = (item) => {
      const { handlerSelect } = props;
      state.value = item.roleName;
      close();
      handlerSelect(item);
    };
    return {
      ...toRefs(state),
      showPopup,
      close,
      select,
    };
  },
};
</script>

<style lang="less" scoped>
.select-item {
  padding: 0.133rem 0;
  &-cnt {
    font-size: 0.48rem;
    padding: 0 0.4rem;
    margin: 0 0.133rem;
    background: #fff;
    // box-shadow: 0 0 0.267rem #e9f0ff;
     box-shadow: 0 0 0.267rem rgb(255 154 152 / 20%);
    border-radius: 0.107rem;
  }
}
.van-cell {
  padding: 0;
  height: 1.067rem;
  line-height: 1.067rem;
  align-items: center;
  font-size: 0.48rem;
  color: #333;
}
:deep(.van-cell__value) {
  font-size: 0.347rem;
  line-height: 0.47rem;
}
.select_box {
  margin-right: 15px;
}
.van-cell__title {
  font-size: 0.48rem;
}
:deep(.select-item-cnt-cell) .van-cell__title span {
  padding-left: 20px;
}
.select-item-cnt-cell {
  padding: 10px;
}

</style>
